"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsData = void 0;
const queries_1 = require("./queries");
const api_js_1 = __importDefault(require("../../utils/api.js"));
const getProductsData = async (apiRoutes, { productCodes = [], modifiers = [] }) => {
    try {
        const query = queries_1.GET_PRODUCTS_DATA;
        const variables = {
            productCodes,
            modifiers
        };
        const { products } = await (0, api_js_1.default)(apiRoutes.catalog, { query, variables });
        return products;
    }
    catch (error) {
        const errorMessage = `Error fetching recommended product list with data: productCodes: ${JSON.stringify(productCodes)}, modifiers:  ${JSON.stringify(modifiers)}`;
        console.error('[Catalog: getProductsData]:', errorMessage, error, false);
        return [];
    }
};
exports.getProductsData = getProductsData;
//# sourceMappingURL=index.js.map